module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon"
  }, [_c('xk-coupon-nav', {
    attrs: {
      "data": _vm.navDataFn
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "couponContent"
  }, [_c('router-view')], 1), _vm._v("\n  " + _vm._s(_vm.v5zcCoupon) + "\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3897d5d9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mewallet/coupon/coupon.vue
// module id = 523
// module chunks = 0